<button
  [class]="'s__btn s__btn--' + variant()"
  [disabled]="disabled()"
  [type]="type()"
  (click)="clicked.emit($event)"
>
  <ng-content />
</button>
